module.exports = __webpack_public_path__ + "img/header-diamondJewelryDelicateJewels@2x.deb9a21.jpg";